import { ReportApplianceInformationType, ReportAttachmentType, ReportDeficiencyType, ReportInformationType, ReportLimitationType, ReportSubsystemType, ReportSystemType } from "./generated";

export type CollectEnum = 'no_collect' | 'collect' | 'required';

export type Section =
  | 'Roof' | 'Exterior' | 'Basement | Foundation | Crawlspace & Structure' | 'HVAC' | 'Plumbing'
  | 'Electrical' | 'Fireplace' | 'Attic | Insulation & Ventilation' | 'Doors | Windows & Interior'
  | 'Built-In Appliance' | 'Garage';

export type Severity = 'safety' | 'repair' | 'monitor';

export type ReportItemType = ReportSystemType | ReportSubsystemType | ReportInformationType | ReportApplianceInformationType | ReportDeficiencyType | ReportLimitationType | ReportAttachmentType;

export type Dictionary<T> = { [key: string]: T };

export enum MediaTypeEnum {
  any = 'any_media_type',
  video = 'video',
  photo = 'photo',
  sphere = 'photo_sphere',
  pdf = 'pdf',
}
